export default __webpack_public_path__ + "static/media/BCA30.afb6f63b.jpg";